import { render, staticRenderFns } from "./ShowSecurityRoleModal.vue?vue&type=template&id=4db8ff11&"
import script from "./ShowSecurityRoleModal.vue?vue&type=script&lang=js&"
export * from "./ShowSecurityRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports